var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.valueData
    ? _c("div", { staticClass: "proof-of-value" }, [
        _c("p", { staticClass: "back" }, [
          _c(
            "span",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c("a-icon", { attrs: { type: "left" } }),
              _c("span", { class: [_vm.lang] }, [
                _vm._v(_vm._s(_vm.$t("POVBack"))),
              ]),
            ],
            1
          ),
        ]),
        _c("section", { staticClass: "proof-of-value" }, [
          _c("section", { staticClass: "overview-card" }, [
            _c("div", { staticClass: "overview-head" }, [
              _c("span", { staticClass: "check-mark" }, [_vm._v("✅")]),
              _c("h1", { attrs: { "data-v-46e5a178": "" } }, [
                _c("strong", [
                  _vm._v('"' + _vm._s(_vm.valueData.campaign_name) + '"'),
                ]),
                _vm._v(" is ready — see what it'll deliver before you launch"),
              ]),
            ]),
            _c("p", { staticClass: "overview-sub" }, [
              _vm._v(_vm._s(_vm.$t("POVOverviewSub"))),
            ]),
          ]),
          _c("div", { staticClass: "divider" }, [
            _c(
              "section",
              {
                staticClass: "progress-card",
                class: { hide: _vm.loading1 == 3 && _vm.loading2 == 3 },
              },
              [
                _c("div", { staticClass: "progress-head" }, [
                  _c("div", { staticClass: "progress-title" }, [
                    _c("span", { staticClass: "head-spinner" }),
                    _c("h3", [_vm._v(_vm._s(_vm.$t("POVLoadingTitle")))]),
                  ]),
                  _c("div", { staticClass: "progress-timer" }, [
                    _c("div", { staticClass: "timer-value" }, [
                      _vm._v(_vm._s(_vm.$t("POVLoadingTimer"))),
                    ]),
                    _c("div", { staticClass: "timer-sub" }, [
                      _vm._v(_vm._s(_vm.$t("POVLoadingTimerSub"))),
                    ]),
                  ]),
                ]),
                _c("p", { staticClass: "progress-sub" }, [
                  _vm._v(_vm._s(_vm.$t("POVLoadingDesc"))),
                ]),
                _vm._m(0),
                _c("ul", { staticClass: "progress-steps" }, [
                  _c("li", { staticClass: "doing" }, [
                    _vm.loading1 == 2
                      ? _c("span", { staticClass: "step-num" }, [_vm._v("1")])
                      : _vm._e(),
                    _vm.loading1 == 3
                      ? _c(
                          "i",
                          { staticClass: "anticon anticon-check-circle" },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  viewBox: "64 64 896 896",
                                  "data-icon": "check-circle",
                                  width: "1em",
                                  height: "1em",
                                  fill: "currentColor",
                                  "aria-hidden": "true",
                                  focusable: "false",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "step-info" }, [
                      _c("div", { staticClass: "step-name" }, [
                        _vm._v(_vm._s(_vm.$t("POVLoadingStep1"))),
                      ]),
                      _c("div", { staticClass: "step-desc" }, [
                        _vm._v(_vm._s(_vm.$t("POVLoadingStep1Desc"))),
                      ]),
                    ]),
                    _vm.loading1 == 2
                      ? _c("span", { staticClass: "step-badge doing" }, [
                          _vm._v(_vm._s(_vm.$t("POVLoadingBadgeIn"))),
                        ])
                      : _vm._e(),
                    _vm.loading1 == 3
                      ? _c("span", { staticClass: "step-badge doing" }, [
                          _vm._v("Complete"),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "li",
                    {
                      class: {
                        wait: _vm.loading2 == 1,
                        doing: _vm.loading2 == 2 || _vm.loading2 == 3,
                      },
                    },
                    [
                      _vm.loading2 == 2 || _vm.loading2 == 1
                        ? _c("span", { staticClass: "step-num" }, [_vm._v("2")])
                        : _vm._e(),
                      _vm.loading2 == 3
                        ? _c(
                            "i",
                            { staticClass: "anticon anticon-check-circle" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    viewBox: "64 64 896 896",
                                    "data-icon": "check-circle",
                                    width: "1em",
                                    height: "1em",
                                    fill: "currentColor",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "step-info" }, [
                        _c("div", { staticClass: "step-name" }, [
                          _vm._v(_vm._s(_vm.$t("POVLoadingStep2"))),
                        ]),
                        _c("div", { staticClass: "step-desc" }, [
                          _vm._v(_vm._s(_vm.$t("POVLoadingStep2Desc"))),
                        ]),
                      ]),
                      _vm.loading2 == 1
                        ? _c("span", { staticClass: "step-badge wait" }, [
                            _vm._v(_vm._s(_vm.$t("POVLoadingBadgeWait"))),
                          ])
                        : _vm._e(),
                      _vm.loading2 == 2
                        ? _c("span", { staticClass: "step-badge doing" }, [
                            _vm._v(_vm._s(_vm.$t("POVLoadingBadgeIn"))),
                          ])
                        : _vm._e(),
                      _vm.loading2 == 3
                        ? _c("span", { staticClass: "step-badge doing" }, [
                            _vm._v("Complete"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "progress-note" },
                  [
                    _c("p", [_vm._v(_vm._s(_vm.$t("POVLoadingNote")))]),
                    _c(
                      "a-button",
                      {
                        staticClass: "skip-btn",
                        attrs: { size: "large" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("publishDirectly")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("POVLoadingSkipBtn")) + " ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm.loading1 == 1 || _vm.loading1 == 2
              ? _c("section", { staticClass: "step-card" }, [
                  _c("header", { staticClass: "step-title" }, [
                    _c("span", { staticClass: "step-num" }, [_vm._v("1")]),
                    _c("h2", [_vm._v(_vm._s(_vm.$t("POVLoadingCard1Title")))]),
                    _c("span", { staticClass: "head-status doing" }, [
                      _c("i", { staticClass: "status-dot" }),
                      _vm._v(_vm._s(_vm.$t("POVLoadingCard1Status"))),
                    ]),
                  ]),
                  _c("div", { staticClass: "loading-body" }, [
                    _c("span", { staticClass: "body-spinner" }),
                    _c("div", { staticClass: "loading-text" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.$t("POVLoadingCard1Msg")))]),
                      _c("p", [_vm._v(_vm._s(_vm.$t("POVLoadingCard1Sub")))]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm.loading1 == 3
            ? _c("section", { staticClass: "step-card" }, [
                _c("header", { staticClass: "step-title" }, [
                  _c("span", { staticClass: "step-num" }, [_vm._v("1")]),
                  _c("h2", [
                    _vm._v("About to reach out to the "),
                    _c("strong", { staticClass: "hl-blue" }, [
                      _vm._v(
                        _vm._s(
                          _vm.valueData.target_preview
                            ? _vm.valueData.target_preview.target_count
                            : 0
                        )
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.valueData.campaign_type == 1
                            ? "customers"
                            : "candidates"
                        ) +
                        " from the URL you entered"
                    ),
                  ]),
                ]),
                _c("p", {
                  staticClass: "source-line",
                  domProps: { innerHTML: _vm._s(_vm.$t("POVSourceLine")) },
                }),
                _c(
                  "div",
                  { staticClass: "url-pill" },
                  [
                    _c("a-icon", { attrs: { type: "link" } }),
                    _vm._v(" " + _vm._s(_vm.valueData.search_url) + " "),
                  ],
                  1
                ),
                _c(
                  "ul",
                  { staticClass: "candidate-list" },
                  _vm._l(_vm.candidateList, function (item, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "candidate-item" },
                      [
                        !item.head_img
                          ? _c(
                              "span",
                              {
                                staticClass: "avatar",
                                style: { background: "rgb(14, 117, 106)" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getFirstCharUpper(item.user_name)
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", {
                              staticClass: "avatar",
                              style: {
                                backgroundImage: `url(${item.head_img})`,
                              },
                            }),
                        _c("div", { staticClass: "candidate-meta" }, [
                          _c("div", { staticClass: "candidate-name" }, [
                            _vm._v(_vm._s(item.user_name)),
                          ]),
                          _c("div", { staticClass: "candidate-role" }, [
                            _vm._v(_vm._s(item.job_title)),
                          ]),
                        ]),
                        _c("span", { staticClass: "status-tag" }, [
                          _vm._v(_vm._s(_vm.$t("POVStatusTag"))),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _c("p", {
                  staticClass: "footnote",
                  domProps: { innerHTML: _vm._s(_vm.$t("POVStep1Footnote")) },
                }),
              ])
            : _vm._e(),
          _vm.loading2 == 1 || _vm.loading2 == 2
            ? _c("div", { staticClass: "divider" }, [
                _c("section", { staticClass: "step-card" }, [
                  _c("header", { staticClass: "step-title" }, [
                    _c("span", { staticClass: "step-num" }, [_vm._v("2")]),
                    _c("h2", [_vm._v(_vm._s(_vm.$t("POVLoadingCard2Title")))]),
                    _vm.loading2 == 1
                      ? _c("span", { staticClass: "head-status wait" }, [
                          _vm._v(_vm._s(_vm.$t("POVLoadingCard2Status"))),
                        ])
                      : _vm._e(),
                    _vm.loading2 == 2
                      ? _c("span", { staticClass: "head-status doing" }, [
                          _c("i", { staticClass: "status-dot" }),
                          _vm._v("In progress about 1 min"),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "loading-body" }, [
                    _c("span", { staticClass: "body-spinner" }),
                    _c("div", { staticClass: "loading-text" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.$t("POVLoadingCard2Msg")))]),
                      _c("p", [_vm._v(_vm._s(_vm.$t("POVLoadingCard2Sub")))]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.loading2 == 3
            ? _c("section", { staticClass: "step-card" }, [
                _c("header", { staticClass: "step-title" }, [
                  _c("span", { staticClass: "step-num" }, [_vm._v("2")]),
                  _c("h2", [
                    _vm._v(" " + _vm._s(_vm.$t("POVStep2Title")) + " "),
                    _c("small", [_vm._v(_vm._s(_vm.$t("POVStep2Note")))]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "conv-container" },
                  [
                    _vm._l(_vm.talkLiST, function (item, index) {
                      return [
                        _c("div", { key: index, staticClass: "conv-head" }, [
                          _c(
                            "span",
                            {
                              staticClass: "avatar",
                              style: { background: "#0e756a" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getFirstCharUpper(item.profile.user_name)
                                )
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "conv-head-meta" }, [
                            _c("div", { staticClass: "candidate-name" }, [
                              _vm._v(_vm._s(item.profile.user_name)),
                            ]),
                            _c("div", { staticClass: "candidate-role" }, [
                              _vm._v(
                                " " + _vm._s(item.profile.job_title) + " "
                              ),
                            ]),
                          ]),
                          _c("span", { staticClass: "warn-tag" }, [
                            _vm._v(_vm._s(_vm.$t("POVWarnTag"))),
                          ]),
                        ]),
                        _c(
                          "div",
                          { key: index + "chat", staticClass: "chat-area" },
                          _vm._l(item.messages, function (msg, idx) {
                            return _c(
                              "div",
                              {
                                key: idx,
                                staticClass: "chat-line",
                                class: { mine: msg.sender === "candidate" },
                              },
                              [
                                msg.sender === "agent"
                                  ? _c("span", { staticClass: "chat-avatar" }, [
                                      _vm._v("AI"),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "chat-bubble" }, [
                                  _vm._v(_vm._s(msg.content)),
                                ]),
                                msg.sender === "candidate"
                                  ? _c(
                                      "span",
                                      { staticClass: "chat-avatar me" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFirstCharUpper(
                                              item.profile.user_name
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    }),
                  ],
                  2
                ),
                _c("p", { staticClass: "footnote footnote-note" }, [
                  _vm._v(_vm._s(_vm.$t("POVStep2Footnote"))),
                ]),
              ])
            : _vm._e(),
          _c("section", { staticClass: "step-card result-step" }, [
            _c("header", { staticClass: "step-title" }, [
              _c("span", { staticClass: "step-num" }, [_vm._v("3")]),
              _c("h2", [_vm._v(_vm._s(_vm.$t("POVStep3Title")))]),
            ]),
            _c("div", { staticClass: "result-grid" }, [
              _c("div", { staticClass: "result-card reply" }, [
                _c("div", { staticClass: "result-label" }, [
                  _vm._v(_vm._s(_vm.$t("POVResultReplyLabel"))),
                ]),
                _c("div", { staticClass: "result-value" }, [
                  _vm._v(_vm._s(_vm.$t("POVResultReplyValue"))),
                ]),
              ]),
              _c("div", { staticClass: "result-card interest" }, [
                _c("div", { staticClass: "result-label" }, [
                  _vm._v(_vm._s(_vm.$t("POVResultInterestLabel"))),
                ]),
                _c("div", { staticClass: "result-value" }, [_vm._v("20 +")]),
              ]),
            ]),
          ]),
          _c(
            "section",
            { staticClass: "safe-tip" },
            [
              _c("a-icon", { attrs: { type: "safety" } }),
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.$t("POVSafeTip")) },
              }),
            ],
            1
          ),
          _c("section", { staticClass: "action-bar" }, [
            _c("div", { staticClass: "action-left" }, [
              _c("div", { staticClass: "action-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("POVActionTitle")) + " "),
              ]),
              _c("div", { staticClass: "action-sub" }, [
                _vm._v(" " + _vm._s(_vm.$t("POVActionSub")) + " "),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "action-right" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "adjust-btn",
                    attrs: { size: "large" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("POVAdjustBtn")) + " ")]
                ),
                _c(
                  "a-button",
                  {
                    staticClass: "confirm-btn",
                    attrs: { type: "primary", size: "large" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("publishDirectly")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("POVConfirmBtn")) + " ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "progress-track" }, [
      _c("div", { staticClass: "progress-fill" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }